// Generated from @cascade/api-contracts. Do not edit.
// Run: pnpm --filter @cascade/api-client build

import type {
  TApiRequestOptions,
  TApiTransport,
} from '#request/request.types.ts';
import type {
  TAddAdminRequestPayload,
  TAddAdminResponsePayload,
  TAddToDomainToAclRequestPayload,
  TAddToDomainToAclResponsePayload,
  TCheckEmailAccessRequestPayload,
  TCheckEmailAccessResponsePayload,
  TDeleteAdminRequestPayload,
  TDeleteAdminResponsePayload,
  TDeleteFromDomainAclRequestPayload,
  TDeleteFromDomainAclResponsePayload,
  TDeleteFromEmailAclRequestPayload,
  TDeleteFromEmailAclResponsePayload,
  TGetAdminsRequestPayload,
  TGetAdminsResponsePayload,
  TGetDomainAclRequestPayload,
  TGetDomainAclResponsePayload,
  TGetEmailAclRequestPayload,
  TGetEmailAclResponsePayload,
  TSetToEmailAclRequestPayload,
  TSetToEmailAclResponsePayload,
} from './acls.types.ts';

export const createAclsApi = (transport: TApiTransport) => ({
  /** Adds a project admin */
  addAdmin: (payload: TAddAdminRequestPayload, options?: TApiRequestOptions) =>
    transport.post<TAddAdminRequestPayload, TAddAdminResponsePayload>(
      '/add_admin',
      payload,
      options,
    ),

  /** Adds a domain to the project's access list */
  addToDomainAcl: (
    payload: TAddToDomainToAclRequestPayload,
    options?: TApiRequestOptions,
  ) =>
    transport.post<
      TAddToDomainToAclRequestPayload,
      TAddToDomainToAclResponsePayload
    >('/add_to_domain_acl', payload, options),

  /** Checks whether an email has project access */
  checkEmailAccess: (
    payload: TCheckEmailAccessRequestPayload,
    options?: TApiRequestOptions,
  ) =>
    transport.post<
      TCheckEmailAccessRequestPayload,
      TCheckEmailAccessResponsePayload
    >('/check_email_access', payload, options),

  /** Removes a project admin */
  deleteAdmin: (
    payload: TDeleteAdminRequestPayload,
    options?: TApiRequestOptions,
  ) =>
    transport.post<TDeleteAdminRequestPayload, TDeleteAdminResponsePayload>(
      '/delete_admin',
      payload,
      options,
    ),

  /** Removes a domain from the project's access list */
  deleteFromDomainAcl: (
    payload: TDeleteFromDomainAclRequestPayload,
    options?: TApiRequestOptions,
  ) =>
    transport.post<
      TDeleteFromDomainAclRequestPayload,
      TDeleteFromDomainAclResponsePayload
    >('/delete_from_domain_acl', payload, options),

  /** Removes an email from the project's access list */
  deleteFromEmailAcl: (
    payload: TDeleteFromEmailAclRequestPayload,
    options?: TApiRequestOptions,
  ) =>
    transport.post<
      TDeleteFromEmailAclRequestPayload,
      TDeleteFromEmailAclResponsePayload
    >('/delete_from_email_acl', payload, options),

  /** Lists project admins */
  getAdmins: (
    payload: TGetAdminsRequestPayload,
    options?: TApiRequestOptions,
  ) =>
    transport.post<TGetAdminsRequestPayload, TGetAdminsResponsePayload>(
      '/get_admins',
      payload,
      options,
    ),

  /** Returns the project's domain access list */
  getDomainAcl: (
    payload: TGetDomainAclRequestPayload,
    options?: TApiRequestOptions,
  ) =>
    transport.post<TGetDomainAclRequestPayload, TGetDomainAclResponsePayload>(
      '/get_domain_acl',
      payload,
      options,
    ),

  /** Returns the project's email access list */
  getEmailAcl: (
    payload: TGetEmailAclRequestPayload,
    options?: TApiRequestOptions,
  ) =>
    transport.post<TGetEmailAclRequestPayload, TGetEmailAclResponsePayload>(
      '/get_email_acl',
      payload,
      options,
    ),

  /** Adds an email to the project's access list */
  setToEmailAcl: (
    payload: TSetToEmailAclRequestPayload,
    options?: TApiRequestOptions,
  ) =>
    transport.post<TSetToEmailAclRequestPayload, TSetToEmailAclResponsePayload>(
      '/set_to_email_acl',
      payload,
      options,
    ),
});
